import React from 'react';
import { Link } from 'react-router-dom';

import { Breadcrumbs } from '@mui/material';

import useIsMobile from 'hooks/use-is-mobile';

import useStyles from './styles';

import Title from '../Title';

interface Props {
    title: string;
    smaller?: boolean;
    blacken?: boolean;
    description?: string;
    breadcrumb?: string;
    buttons?: React.ReactNode;
    illustration?: React.ReactNode;
    className?: string;
}

const TitleSection: React.FC<Props> = ({
    title,
    smaller,
    blacken,
    description,
    breadcrumb = title,
    buttons,
    illustration,
    className
}) => {
    const { classes, cx } = useStyles({ buttons: !!buttons, illustration: !!illustration, smaller: !!smaller });
    const isMobile = useIsMobile();
    return (
        <div className={cx(classes.root, className)}>
            <Breadcrumbs className={classes.breadcrumbs}>
                <Link to="/" className={classes.breadcrumb}>
                    {'Main'}
                </Link>
                <span>{breadcrumb}</span>
            </Breadcrumbs>
            <div className={classes.text}>
                <Title variant="h1" align={isMobile ? 'center' : 'left'} smaller={smaller} blacken={blacken}>
                    {title}
                </Title>
                {description ? <p className={classes.description}>{description}</p> : null}
            </div>
            {buttons ? <div className={classes.buttons}>{buttons}</div> : null}
            {illustration ? <div className={classes.illustration}>{illustration}</div> : null}
        </div>
    );
};
export default TitleSection;
